import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import SimulationRow from '../SimulationRow/SimulationRow';
import './SimulationTable.css';
import { useTranslation } from 'react-i18next';
import React from 'react';
import ExploreRules from '../../../models/EquivalencyRuleActivity';
import { v4 as uuidv4 } from 'uuid';

interface SimulationTableProps {
  rules: ExploreRules[]
}

const SimulationTable:React.FC<SimulationTableProps> = ({ rules }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography
        color="primary"
        variant="h5"
        fontWeight="500"
        style={{ margin: '10px 0', fontSize: '17px' }}
      >
        {t('equivalenciesTitle')}
      </Typography>
        <TableContainer sx={{ flex: '1' }}>
          <Table key={rules.toString()} className="REQXXI-EquivalencyRule-Table" stickyHeader size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell className="REQXXI-SimulationTable-ActivitiesTarget" align="left" scope="row">
                  <Typography> {t('sourceActivity')}</Typography>
                </TableCell>
                <TableCell className="REQXXI-SimulationTable-ActivitiesSource" align="left">
                  <Typography> {t('targetActivity')}</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ overflow: 'auto' }}>
              {rules?.map((row) => (
                <SimulationRow
                  key={uuidv4()}
                  row={row}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer >
    </>
  );
};

export default SimulationTable;
